var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4",class:'row-cols-xl-' + _vm.maxPerRow},_vm._l((_vm.products),function(product){return _c('div',{staticClass:"col"},[_c('product',{attrs:{"product":product,"loading":_vm.loading}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }